export const LoginFieldNames = {
  EMAIL: 'email',
  PASSWORD: 'password'
}
